import React, { useEffect, useState } from 'react'
import TicketContext from './TicketContext';
import axios from 'axios';

const TicketProvider = ({children}) => {
    const [currTicket, setCurrTicket] = useState();
    const [showTicket, setShowTicket] = useState(false);


    const handleShowTicket = () => {
        setShowTicket(prevState => !prevState);
      };


      const getTicketDetails = async (id) => {
        try {
            await axios.get(`https://event-finder12.onrender.com/ticket/getTicketDetails/${id}`).then((res)=> {
            setCurrTicket(res.data)
            handleShowTicket();
            console.log(res.data)
          })
        } catch(err) {
          console.log(err);
        }
      }

      const contextValue = {
        handleShowTicket,getTicketDetails,showTicket,currTicket
      };
    
      return (
        <TicketContext.Provider value={contextValue}>
          {children}
        </TicketContext.Provider>
      );
}

export default TicketProvider